export default "__VITE_ASSET__Cr23qOvy__"